import React, { Component } from "react";
import axios from "axios";
import { Link } from "react-router-dom";
import isEmpty from "lodash/isEmpty";
import sanitizeHtml from "sanitize-html";

// Components
import Loader from "../../utils/Loader";

// State
import { REACT_APP_API_URL, REACT_APP_SITE_KEY } from "../../../shared/vars";

class JerseyFormPrint extends Component {
	constructor(props) {
		super(props);
		this.state = {
			id: !!props.match.params.id ? props.match.params.id : "",
			recordLoading: true,
			data: {},
			errors: {}
		};
	}

	componentDidMount() {
		this.loadData();
	}

	componentDidUpdate() {
		if (this.printElement) {
			window.print();
		}
	}

	loadData() {
		const apiEndpoint = `custom/spitsgear/entry?id=${this.state.id}`;

		const AUTH_HEADER = {
			Authorization: REACT_APP_SITE_KEY
		};
		return axios
			.get(REACT_APP_API_URL + apiEndpoint, { headers: AUTH_HEADER })
			.then(response => {
				// Request error
				if (response.status !== 200 || (response.data.status && response.data.status !== 200)) {
					this.setState({
						recordLoading: false,
						errors: {
							...this.state.errors,
							general: response.data.message
						}
					});

					return;
				}

				// No results!
				if (isEmpty(response.data)) {
					this.setState({
						recordLoading: false,
						errors: {
							general: "Unable to find record."
						}
					});

					return;
				}

				// Success
				this.setState({
					recordLoading: false,
					data: response.data
				});
			})
			.catch(err => {
				if (err.response) {
					this.setState({
						recordLoading: false,
						errors: {
							...this.state.errors,
							general: err.response.data.errors ? err.response.data.errors : err.response.data.message
						}
					});
				} else {
					this.setState({
						recordLoading: false,
						errors: {
							...this.state.errors,
							general: err.message
						}
					});
				}
			});
	}

	render() {
		const { recordLoading, id, data, errors } = this.state;

		return (
			<main className="body_container padded_top padded_bottom">
				{!!errors.general && <div className="error msg_animate">{errors.general}</div>}

				<Link to="/jersey-form">Go back to form</Link>
				<br />
				<br />

				{recordLoading ? (
					<Loader />
				) : (
					id && (
						<div
							ref={instance => {
								this.printElement = instance;
							}}
						>
							<table>
								<tbody>
									<tr>
										<td colSpan="4">
											<h2>Order Number: {data.order_number}</h2>
										</td>
									</tr>

									<tr>
										<td colSpan="4">
											<h2>Customer Information</h2>
										</td>
									</tr>

									<tr valign="top">
										<td>First Name:</td>
										<td>{data.fname}</td>
										<td>Last Name:</td>
										<td>{data.lname}</td>
									</tr>

									<tr valign="top">
										<td>Phone</td>
										<td>{data.phone}</td>
										<td>Staff Name</td>
										<td>{data.staff_name}</td>
									</tr>

									<tr valign="top">
										<td>Date Ordered:</td>
										<td>{data.date_ordered}</td>
										<td>Receipt Number:</td>
										<td>{data.receipt_number}</td>
									</tr>

									<tr>
										<td>Notes:</td>
										<td colSpan="3">
											<div dangerouslySetInnerHTML={{ __html: sanitizeHtml(data.notes) }} />
										</td>
									</tr>

									<tr>
										<td colSpan="4">
											<hr />
										</td>
									</tr>

									<tr>
										<td colSpan="4">
											<h2>Product</h2>
										</td>
									</tr>

									<tr valign="top">
										<td>Product:</td>
										<td colSpan={data.product === "Other" ? 3 : ""}>{data.product}</td>
										{data.product === "Other" && <td>Other Product:</td>}
										{data.product === "Other" && <td>{data.other_product}</td>}
									</tr>
									<tr valign="top">
										<td>Style:</td>
										<td colSpan={data.product === "Other" ? 3 : ""}>{data.style}</td>
										{data.style === "Other" && <td>Other Style:</td>}
										{data.style === "Other" && <td>{data.other_style}</td>}
									</tr>
									<tr valign="top">
										<td>Size:</td>
										<td colSpan={data.product === "Other" ? 3 : ""}>{data.size}</td>
										{data.size === "Other" && <td>Other Size:</td>}
										{data.size === "Other" && <td>{data.other_size}</td>}
									</tr>
									<tr valign="top">
										<td>Condition:</td>
										<td>{data.condition_option}</td>
										<td />
										<td />
									</tr>

									<tr>
										<td colSpan="4">
											<hr />
										</td>
									</tr>

									<tr>
										<td colSpan="4">
											<h2>Customization</h2>
										</td>
									</tr>

									<tr valign="top">
										<td colSpan="4">Type: {data.name_option}</td>
									</tr>

									{data.name_option === "Custom Name" && (
										<tr valign="top" className="custom-name-set">
											<td>Custom Name:</td>
											<td>{data.custom_name}</td>
											<td>Custom Number:</td>
											<td>{data.custom_number}</td>
										</tr>
									)}

									{data.name_option === "Roster Name" && (
										<tr valign="top" className="custom-name-set">
											<td>Player Roster:</td>
											<td colSpan="3">{data.player}</td>
										</tr>
									)}

									<tr valign="top">
										<td colSpan="4">Special Instructions: {data.special_instructions}</td>
									</tr>

									<tr>
										<td colSpan="4">
											<hr />
										</td>
									</tr>

									<tr>
										<td colSpan="4">
											<h2>Additional Options (Captain or Alternate Letter)</h2>
										</td>
									</tr>

									<tr valign="top">
										<td colSpan="4">{data.additional}</td>
									</tr>
								</tbody>
							</table>
							<br />
							<br />

							<div style={{ fontSize: "1.5em" }}>
								<u>Customer Approval</u>
								<br />
								<br />
								<table>
									<tbody>
										<tr>
											<td>Print Name: </td>
											<td>_________________________</td>
										</tr>
										<tr>
											<td>Signature: </td>
											<td>_________________________</td>
										</tr>
										<tr>
											<td>Date: </td>
											<td>_________________________</td>
										</tr>
									</tbody>
								</table>
							</div>
						</div>
					)
				)}
			</main>
		);
	}
}

export default JerseyFormPrint;



// WEBPACK FOOTER //
// ./src/components/custom/jersey-form/JerseyFormPrint.js